<template>
    <div id="app">
        <div class="scrollbar_style">
            <router-view></router-view>
        </div>
    </div>
</template>

<script type="text/javascript">
    Date.prototype.format = function(fmt) {
        let ret;
        const opt = {
            "Y+": this.getFullYear().toString(),        // 年
            "m+": (this.getMonth() + 1).toString(),     // 月
            "d+": this.getDate().toString(),            // 日
            "H+": this.getHours().toString(),           // 时
            "M+": this.getMinutes().toString(),         // 分
            "S+": this.getSeconds().toString()          // 秒
            // 有其他格式化字符需求可以继续添加，必须转化成字符串
        };
        for (let k in opt) {
            ret = new RegExp("(" + k + ")").exec(fmt);
            if (ret) {
                fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
            }
        }
        return fmt; 
    }
    
    import allUrl from './api/allUrl.js'
    import base from './api/base.js'
    import { mapGetters } from 'vuex'
    // import $ from  'jquery'
    // import mCustomScrollbar from './api/jquery.mCustomScrollbar.concat.min.js'

    export default {
        name:'App',
        data(){
            return{
                // i18nArr:['zh-CN','en-US'],
                linkTypeData:{},
                // webapiAmap:false,
                isGoogleapis:false,

                viewWidth:0,
                viewHeight:0,
                viewIndex: 0,
                orientation: 90,
            }
        },
        computed:{
            ...mapGetters({
                version:'version',
                routerStr:'routerStr',
                remRatio:'remRatio',
                sideBarShow:'sideBarShow',
                updateRemRatio:'updateRemRatio',
                role: 'role',

                // isGoogleapis:'isGoogleapis',
                webapiAmap:'webapiAmap',

                isMobile:'isMobile',
            }),
        },
        components:{
            // 'headers':headers,
        },
        beforeCreate(){
        },
        created(){
            

            let storage = window.localStorage;
            let data;
            let url = window.location.href.split("/")[2];
            let protocolStr = document.location.protocol;
            let subStrW = protocolStr=='https:'?'wss:':'ws:';
            let subStrT = new RegExp('http:');//创建正则表达式对象
            let street;
            // console.log(this.version,'-----')
            this.versionFun(this.version)

            if(url == 'localhost:8080' || url == '127.0.0.1:8080' || url == '10.0.0.94:8080'|| url == '10.0.0.164:8080'){
                street = 'lighting.lampmind.com';
                // street = 'www.iotena-web.com';
                protocolStr = 'https:'
                // subStrW = 'wss:'
                // street = '120.77.179.55';

                this.$store.commit('DOMAINNAME',{
                  domainName:'lighting',
                })
                $('html').attr({lang:'zh-cn'})
                // linkType = 'home'
                // this.$store.commit('ROUTERSTRFUN',{
                //   routerStr:'/home',
                // })
                this.$router.push({path:'/home'})
                
            }else{
                street = url;
                // if(url == 'room.lampmind.com'){
                //     this.$store.commit('VERSION',{
                //       version:'1',
                //     })
                //     this.$store.commit('DOMAINNAME',{
                //       domainName:'room',
                //     })
                // }

            }
            for(let i in allUrl){
                for(let key in allUrl[i]){
                    if(i == 'websocket'){
                        allUrl[i][key]=allUrl[i][key].replace(new RegExp('ws:'),subStrW);
                        allUrl[i][key]=allUrl[i][key].replace(new RegExp('lighting.lampmind.com'),street);
                    }else{
                        allUrl[i][key]=allUrl[i][key].replace(subStrT,protocolStr);
                        allUrl[i][key]=allUrl[i][key].replace(new RegExp('lighting.lampmind.com'),street);
                    }
                }
            }
            function isMobile() {
                // 判断是否为移动设备
                return (
                    typeof window.orientation !== "undefined" || // 判断是否存在window.orientation属性，此属性在移动设备上一般存在
                    navigator.userAgent.indexOf('IEMobile') !== -1 || // 判断是否为Windows Phone
                    navigator.userAgent.indexOf('iPhone') !== -1 || // 判断是否为iPhone
                    navigator.userAgent.indexOf('Android') !== -1 && navigator.userAgent.indexOf('Mobile') !== -1 || // 判断是否为Android手机
                    navigator.userAgent.indexOf('BlackBerry') !== -1 || // 判断是否为BlackBerry
                    navigator.userAgent.indexOf('Opera Mini') !== -1 // 判断是否为Opera Mini浏览器
                );
            }

            if (isMobile()) {
                // console.log('移动端');
                this.$store.commit('isMobileFun',{
                    isMobile: true,
                })
                // document.body.addEventListener('touchmove', function (e) {
                //     e.preventDefault(); 
                // }, {passive: false});
            } else {
                // console.log('PC端');
            }
            // console.log(allUrl)
            let linkTypeArr =  window.location.href.split("/");
            let linkType = linkTypeArr[linkTypeArr.length-1].split("?")[0];
            console.log(storage.getItem('userData'),'--userData--')
            if(storage.getItem('userData')){
                data = JSON.parse(storage.getItem('userData'))
                this.$store.commit('USERDATAFUN',{
                    id:data.id,
                    username:data.username,
                    token:data.token,
                    version:data.version,
                    role:data.role,
                    avatar:data.avatar,
                    
                })
                this.versionFun(data.version,'load')
                this.$store.commit('ROUTERSTRFUN',{
                    routerStr:'/'+linkType
                })
                
                base.websocket(allUrl.websocket.ws, websocket => {
                    // this.websocket_new_em_register = websocket;
                    // console.log(websocket,'------9')
                    // this.websocket.send('{"topic":"new_em_register","username":"' + (data.username + '') + '"}');
                    websocket.send(JSON.stringify({'topic':'/user/login','token':(data.token)}));
                    websocket.onmessage = event => {
                        let data = JSON.parse(event.data);
                        // console.log(data)

                        if (data.topic == "/user/logout") {
                        // console.log(data.token,'--969699----9')
                        this.$confirm(this.$t('App.message.text51'), this.$t('App.message.text4'), {
                            confirmButtonText: this.$t('App.message.text2'),
                        })
                        
                        this.signOut();
                        websocket.close()
                        }
                    }
                }, this)
            }else{
                if(linkType != 'retrievePassword'){
                    storage.setItem('userData','')
                    this.$store.commit('ROUTERSTRFUN',{
                      routerStr:'/login',
                    })
                    this.$router.push({path:'/login'});
                }
            }
            console.log('--sd-s-d-d-')

            this.versionFun(this.version)
            this.$router.beforeEach((to, from, next) => {
                next();
            })
            
            // this.loadJS('https://maps.googleapis.com/maps/api/js?key=AIzaSyD_FHQc9qTI5SPvTBV0SQ-aPS2HJHm8H9U&language=en',function(){})
            // this.loadJS('./src/store/infobox.js',function(){})
            // this.loadJS('./src/store/richmarker.js',function(){})
        },
        mounted(){
            let this_ = this;
            this.viewWidth = document.documentElement.offsetWidth;
            
            if(this.viewWidth >=1920){
                this.viewWidth = 1920
            }
            $('html').css({ 'font-size': this_.viewWidth * 62.5 / 1263.2 + '%' })
            this_.$store.commit('REMRATIOFUN', {
                remRatio: this_.viewWidth * 62.5 / 1263.2 / 100 * 16,
            })

            // this.viewWidth = document.body.clientWidth; //获取可视区域宽度
            this.viewHeight = document.body.clientHeight; //获取可视区域高度

            if(this_.isMobile){
                this_.viewWidth =  1920/1080 *this.viewHeight

                $('html').css({'font-size':this_.viewWidth * 62.5 / 1263.2 + '%' })
                this_.$store.commit('REMRATIOFUN',{
                    remRatio:this_.viewWidth* 62.5 / 1263.2 / 100 * 16,
                }) 
                if ((this_.orientation == 90 || this_.orientation == 270)) {
                    $('body').height(this_.viewHeight+'px')
                    $('#app').height(this_.viewHeight+'px')
                    $('body').width(this_.viewWidth+'px')
                    $('#app').width(this_.viewWidth+'px')
                }
            }
            window.onresize = function(){
                this_.viewWidth = document.documentElement.offsetWidth;
                this_.viewHeight = document.body.clientHeight; //获取可视区域高度
                if(this_.isMobile){
                    this_.viewWidth =  1920/1080 *this_.viewHeight;
                    $('html').css({'font-size':this_.viewWidth * 62.5 / 1263.2 + '%' })
                    this_.$store.commit('REMRATIOFUN',{
                        remRatio:this_.viewWidth* 62.5 / 1263.2 / 100 * 16,
                    })
                    if ((this_.orientation == 90 || this_.orientation == 270)) {
                        $('body').height(this_.viewHeight+'px')
                        $('#app').height(this_.viewHeight+'px')
                        $('body').width(this_.viewWidth+'px')
                        $('#app').width(this_.viewWidth+'px')
                    }
                }else{
                    if(this.viewWidth >=1920){
                        this.viewWidth = 1920
                    }
                    $('html').css({ 'font-size': this_.viewWidth * 62.5 / 1263.2 + '%' })
                    this_.$store.commit('REMRATIOFUN', {
                        remRatio: this_.viewWidth * 62.5 / 1263.2 / 100 * 16,
                    })
                }
                this_.$store.commit('UPDATEREMRATIOFUN',{
                    updateRemRatio:this_.updateRemRatio+1,
                })
                this_.viewIndex ++;
                
            }
            $(window).bind('orientationchange',function(event){
                setTimeout(()=>{
                    this_.orientation = event.orientation|screen.orientation.angle;
                    this_.viewHeight = document.body.clientHeight; //获取可视区域高度
                    this_.viewIndex ++;

                    if(this_.isMobile){
                        this_.viewWidth =  1920/1080 *this_.viewHeight;
                        $('html').css({'font-size':this_.viewWidth * 62.5 / 1263.2 + '%' })
                        this_.$store.commit('REMRATIOFUN',{
                            remRatio:this_.viewWidth* 62.5 / 1263.2 / 100 * 16,
                        }) 
                        if ((this_.orientation == 90 || this_.orientation == 270)) {
                            $('body').height(this_.viewHeight+'px')
                            $('#app').height(this_.viewHeight+'px')
                            $('body').width(this_.viewWidth+'px')
                            $('#app').width(this_.viewWidth+'px')
                        }else{
                            $('body').height('100%')
                            $('#app').height('100%')
                        }
                    }
                },500)
            })
            // console.log(this.i18nArr[this.version],this.version,this.i18nArr)
            // this.$i18n.locale = this.i18nArr[this.version];
        },
        methods:{
            versionFun(val,type){
                // console.log(val,'------------ssssd22222222222222-------')
                this.$store.commit('VERSION',{
                    version:val,
                })
                // let this_ = this;
                console.log(val,val === 1,type,'----versionFun--')
                if(type == 'load'){

                    if (val == 1) {
                        this.$i18n.locale = 'zh-CN';
                        this.loadJS('https://webapi.amap.com/maps?v=1.4.15&key=6f0388812f958e88699f2ea6fede068b&plugin=AMap.MarkerClusterer,AMap.ToolBar,AMap.Autocomplete,AMap.PlaceSearch,AMap.Geocoder,AMap.DistrictSearch,AMap.DistrictLayer,AMap.MassMarks', ()=> {
                            this.loadJS('https://a.amap.com/jsapi_demos/static/china.js', function () { })
                            this.loadJS('https://webapi.amap.com/ui/1.0/main.js?v=1.0.11', function () { })
                            this.loadJS('https://webapi.amap.com/loca?v=1.3.2&key=6f0388812f958e88699f2ea6fede068b', function () { })
                        })
                    }
                    if(val == 0){
                        this.$i18n.locale = 'en-US';
                        if (!this.isGoogleapis) {
                            this.isGoogleapis = true;
                            
                            (g=>{var h,a,k,p="The Google Maps JavaScript API",c="google",l="importLibrary",q="__ib__",m=document,b=window;b=b[c]||(b[c]={});var d=b.maps||(b.maps={}),r=new Set,e=new URLSearchParams,u=()=>h||(h=new Promise(async(f,n)=>{await (a=m.createElement("script"));e.set("libraries",[...r]+"");for(k in g)e.set(k.replace(/[A-Z]/g,t=>"_"+t[0].toLowerCase()),g[k]);e.set("callback",c+".maps."+q);a.src=`https://maps.${c}apis.com/maps/api/js?`+e;d[q]=f;a.onerror=()=>h=n(Error(p+" could not load."));a.nonce=m.querySelector("script[nonce]")?.nonce||"";m.head.append(a)}));d[l]?console.warn(p+" only loads once. Ignoring:",g):d[l]=(f,...n)=>r.add(f)&&u().then(()=>d[l](f,...n))})({
                                key: "AIzaSyBu9LweyAtYu26iTWwzxozPEco1xosnIoI",
                                v: "weekly",
                            });
                        }
                    }
                    if(val == 2){
                        this.$i18n.locale = 'ja';
                        if (!this.isGoogleapis) {
                            this.isGoogleapis = true;
                            
                            (g=>{var h,a,k,p="The Google Maps JavaScript API",c="google",l="importLibrary",q="__ib__",m=document,b=window;b=b[c]||(b[c]={});var d=b.maps||(b.maps={}),r=new Set,e=new URLSearchParams,u=()=>h||(h=new Promise(async(f,n)=>{await (a=m.createElement("script"));e.set("libraries",[...r]+"");for(k in g)e.set(k.replace(/[A-Z]/g,t=>"_"+t[0].toLowerCase()),g[k]);e.set("callback",c+".maps."+q);a.src=`https://maps.${c}apis.com/maps/api/js?`+e;d[q]=f;a.onerror=()=>h=n(Error(p+" could not load."));a.nonce=m.querySelector("script[nonce]")?.nonce||"";m.head.append(a)}));d[l]?console.warn(p+" only loads once. Ignoring:",g):d[l]=(f,...n)=>r.add(f)&&u().then(()=>d[l](f,...n))})({
                                key: "AIzaSyBu9LweyAtYu26iTWwzxozPEco1xosnIoI",
                                v: "weekly",
                            });
                        }
                    }
                }

                // let this_ = this;
                // if(val == '1'){
                //     this.$i18n.locale = 'zh-CN'
                //     // if(!this.webapiAmap){
                //     //     this.loadJS('https://webapi.amap.com/maps?v=1.4.6&key=192cfd61cc0fbe8c2cf8d5c314f43bb3&plugin=AMap.MarkerClusterer,AMap.ToolBar,AMap.Autocomplete,AMap.PlaceSearch,AMap.Geocoder,AMap.Geolocation',function(){
                //     //         this_.loadJS('https://webapi.amap.com/ui/1.0/main.js?v=1.0.11',function(){})
                //     //         this_.$store.commit('WEBAPIAMAP',{
                //     //             webapiAmap:true
                //     //         })
                //     //     })
                //     // }
                // }
                // if(val == '0'){
                //     this.$i18n.locale = 'en-US'
                //   // if(!this.isGoogleapis){
                //   //   this.loadJS('https://maps.googleapis.com/maps/api/js?key=AIzaSyBu9LweyAtYu26iTWwzxozPEco1xosnIoI&language=en',function(){
                //   //       this_.loadJS('./js/infobox.js',function(){
                //   //           this_.loadJS('./js/richmarker.js',function(){
                //   //               this_.$store.commit('ISGOOGLEAPIS',{
                //   //                   isGoogleapis:true
                //   //               })
                //   //           })
                //   //       })
                //   //   })
                //   // }
                // }
            },
            loadJS( url, callback ){
                let script = document.createElement('script'),
                fn = callback || function(){};
                script.type = 'text/javascript';
                //IE
                if(script.readyState){
                  script.onreadystatechange = function(){
                    if( script.readyState == 'loaded' || script.readyState == 'complete' ){
                      script.onreadystatechange = null;
                      fn();
                    }
                  };
                }else{
                  //其他浏览器
                  script.onload = function(){
                    fn();
                  };
                }
                script.src = url;
                document.getElementsByTagName('head')[0].appendChild(script);
            },
            //退出登录
            signOut(){
                this.$confirm(this.$t('App.message.text41'), this.$t('App.message.text4'), {
                    confirmButtonText: this.$t('App.message.text5'),
                    cancelButtonText: this.$t('App.message.text6'),
                    type: 'warning'
                }).then(() => {
                    base.ajax_post(
                    allUrl.login.logout,
                    {
                    username: this.username,
                    clientType: this.os,
                    token: this.token,
                    version: this.version,
                    },
                    {},
                    (data) => {
                    this.$message({
                        showClose: true,
                        message: data.msg,
                        type: "success",
                    });
                    },
                    this)
                    
                    localStorage.clear()
                    window.sessionStorage.clear()
                    this.$router.push('/login')

                }).catch(() => {
                    this.$message({
                    type: 'info',
                    message: this.$t('App.message.text52')
                    });
                });
            },
            // getStyleTemplate(data) {
            //     const colorMap = {
            //         '#faedda': 'color1',
            //         '#fdbe6e': 'color2',
            //         '#f2cd9b': 'color3',
            //         '#fe5e08': 'color4',
            //         '#e09259': 'color5',
            //         '#f2cd9b': 'color6',
            //         '#f44336': 'color7',
            //         '#682411': 'color8',
            //         '#faedda': 'color9',
            //     };
            //     Object.keys(colorMap).forEach((key) => {
            //         const value = colorMap[key];
            //         data = data.replace(new RegExp(key, 'ig'), value);
            //     });
            //     return data;
            // }
        }
    }
</script>

<style type="text/css" lang="less">
    // @font-face {
    //     font-family: 'AllRoundGothic-Book';
    //     src: url('./style/font/ALLROUNDGOTHIC-BOOK.TTF');
    //     // src:
    //     //   url('./style/font-pf/PingFangRegular.eot?#font-spider') format('embedded-opentype'),
    //     //   url('./style/font-pf/PingFangRegular.woff') format('woff'),
    //     //   url('./style/font-pf/PingFangRegular.ttf') format('truetype'),
    //     //   url('./style/font-pf/PingFangRegular.svg') format('svg');
    //     font-weight: normal;
    //     font-style: normal;
    // }
    // @font-face {
    //     font-family: 'PingFangSC-Regular';
    //     src: url('./style/font-pf/PingFangRegular.ttf');
    //     src:
    //       url('./style/font-pf/PingFangRegular.eot?#font-spider') format('embedded-opentype'),
    //       url('./style/font-pf/PingFangRegular.woff') format('woff'),
    //       url('./style/font-pf/PingFangRegular.ttf') format('truetype'),
    //       url('./style/font-pf/PingFangRegular.svg') format('svg');
    //     font-weight: normal;
    //     font-style: normal;
    // }

    // @font-face {
    //     font-family: 'PingFang-SC-Heavy';
    //     src: url('./style/font-pf/PingFangHeavy.eot');
    //     src:
    //       url('./style/font-pf/PingFangHeavy.eot?#font-spider') format('embedded-opentype'),
    //       url('./style/font-pf/PingFangHeavy.woff') format('woff'),
    //       url('./style/font-pf/PingFangHeavy.ttf') format('truetype'),
    //       url('./style/font-pf/PingFangHeavy.svg') format('svg');
    //     font-weight: normal;
    //     font-style: normal;
    // }

    // @font-face {
    //     font-family: 'AlibabaPuHuiTiR';
    //     src: url('./style/font-al/Alibaba-PuHuiTi-Regular.eot');
    //     src:
    //       url('./style/font-al/Alibaba-PuHuiTi-Regular.eot?#font-spider') format('embedded-opentype'),
    //       url('./style/font-al/Alibaba-PuHuiTi-Regular.woff') format('woff'),
    //       url('./style/font-al/Alibaba-PuHuiTi-Regular.ttf') format('truetype'),
    //       url('./style/font-al/Alibaba-PuHuiTi-Regular.svg') format('svg');
    //     font-weight: normal;
    //     font-style: normal;
    // }
    // @font-face {
    //     font-family: 'AlibabaPuHuiTiH';
    //     src: url('./style/font-al/Alibaba-PuHuiTi-Heavy.ttf');
    //     src:
    //       url('./style/font-al/Alibaba-PuHuiTi-Heavy.eot?#font-spider') format('embedded-opentype'),
    //       url('./style/font-al/Alibaba-PuHuiTi-Heavy.woff') format('woff'),
    //       url('./style/font-al/Alibaba-PuHuiTi-Heavy.ttf') format('truetype'),
    //       url('./style/font-al/Alibaba-PuHuiTi-Heavy.svg') format('svg');
    //     font-weight: normal;
    //     font-style: normal;
    // }
    // @font-face {
    //     font-family: 'AlibabaPuHuiTiB';
    //     src: url('./style/font-al/Alibaba-PuHuiTi-Bold.ttf');
    //     src:
    //       url('./style/font-al/Alibaba-PuHuiTi-Bold.eot?#font-spider') format('embedded-opentype'),
    //       url('./style/font-al/Alibaba-PuHuiTi-Bold.woff') format('woff'),
    //       url('./style/font-al/Alibaba-PuHuiTi-Bold.ttf') format('truetype'),
    //       url('./style/font-al/Alibaba-PuHuiTi-Bold.svg') format('svg');
    //     font-weight: normal;
    //     font-style: normal;
    // }
    // @font-face {
    //     font-family: 'AlibabaPuHuiTiL';
    //     src: url('./style/font-al/Alibaba-PuHuiTi-Light.ttf');
    //     src:
    //       url('./style/font-al/Alibaba-PuHuiTi-Light.eot?#font-spider') format('embedded-opentype'),
    //       url('./style/font-al/Alibaba-PuHuiTi-Light.woff') format('woff'),
    //       url('./style/font-al/Alibaba-PuHuiTi-Light.ttf') format('truetype'),
    //       url('./style/font-al/Alibaba-PuHuiTi-Light.svg') format('svg');
    //     font-weight: normal;
    //     font-style: normal;
    // }
    // @font-face {
    //     font-family: 'AlibabaPuHuiTiM';
    //     src: url('./style/font-al/Alibaba-PuHuiTi-Medium.ttf');
    //     src:
    //       url('./style/font-al/Alibaba-PuHuiTi-Medium.eot?#font-spider') format('embedded-opentype'),
    //       url('./style/font-al/Alibaba-PuHuiTi-Medium.woff') format('woff'),
    //       url('./style/font-al/Alibaba-PuHuiTi-Medium.ttf') format('truetype'),
    //       url('./style/font-al/Alibaba-PuHuiTi-Medium.svg') format('svg');
    //     font-weight: normal;
    //     font-style: normal;
    // }
    // @font-face {
    //     font-family: 'bodoni-MT';
    //     src: url('./style/bodoniMT/bodoniMT.ttf');
    // }

    html,body,p,h1,h2,h3,h4,h5,ul,li{
        margin: 0px;
        padding: 0px;
    }
    html,body,#app{
          height: 100%;
          width:100%;
    }
    li{
        list-style:none;/*li去点*/
        box-sizing: border-box;
    }
    a{
        text-decoration: none;
        box-sizing: border-box;
    }
    i{
        font-style: inherit;
    }
    input{
        padding:0;
        outline-style: none;
        box-sizing: border-box;
    }
    div{
        box-sizing: border-box; //border、padding并入宽度。
    }
    .icon{
      background-position: center;
      background-repeat:no-repeat;
      background-size: 100% 100%;
    }
    .select_popper{
      // width: 18.6rem;
      // height: 12.89rem;
      &.el-select-dropdown{

        background: rgba(244, 251, 253, 0.9);
        border: 0.09rem solid #3A636F;
        border-radius: 0.44rem;
        .el-select-dropdown__item{
          font-size: 1.46rem;
          font-family: Calibri;
          font-weight: normal;
          color: #3A636F;
          border-radius: 0.44rem;
          &:hover{
            // background: initial;
            background: rgba(227, 249, 255, 0.9);
            // border: 0.09rem solid #3A636F;
          }
          &.selected{
            background: rgba(227, 249, 255, 0.9);
            border: 0.09rem solid #3A636F;
          }
        }
        .popper__arrow{
          display: none;
        }
      }
    }
    .slider_box {
        position: relative;
        &.color{
            .el-slider__runway{
                border-color: var(--color);
                .el-slider__bar{
                    background: var(--color);
                    border-color: var(--color);
                }
            }
            .el-slider__runway .el-slider__button{
                background: var(--color);
                border-color: var(--color);
            }
        }
      .tooltip_box{
        position: relative;
        height: 2.5rem;
        .tooltip{
          position: absolute;
          left: 0;top: 0;
          font-size: 1.8rem;
          font-family: Calibri;
          font-weight: normal;
          color: #3A636F;
          margin-left: -2.5rem;
          width: 5rem;
          text-align: center;
        }
      }
      .el-slider__runway {
        height: 0.66rem;
        // background: linear-gradient(90deg, #ffffff, #696969);
        background: rgba(153, 153, 153, 1);
        
        border: 0.09rem solid #3a636f;
        border-radius: 0.79rem;
        margin: 0 0 1rem 0;

        .el-slider__bar {
          height: 0.52rem;
          background-color: rgba(0, 198, 255, 1);
        }
        .el-slider__button-wrapper {
          width: 1.58rem;
          height: 1.58rem;
          top: -0.6rem;
        }
        .el-slider__button {
          width: 1.58rem;
          height: 1.58rem;
          background: #00C6FF;
          border: 0.09rem solid #3A636F;
          border-radius: 50%;
          // width: 0.79rem;
          // height: 1.58rem;
          // background: #00c6ff;
          // border: 0.09rem solid #3a636f;
          // border-radius: 0.22rem;
          // cursor: pointer;
        }
      }

      .slider_b {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .span1,
        .span2 {
          font-size: 1.64rem;
          font-family: Calibri;
          font-weight: normal;
          color: #3a636f;
        }
      }
    }
    .el-tooltip__popper.is-dark{
      font-size: 1.64rem;
      font-family: Calibri;
      font-weight: normal;
      color: #3A636F !important;
      background-color: rgba(0,0,0,0) !important;
      margin-bottom: 0 !important;
    }
    .el-tooltip__popper[x-placement^=top] .popper__arrow{
      border-color: rgba(0,0,0,0) !important;
    }
    .el-tooltip__popper[x-placement^=top] .popper__arrow::after{ 
      border-color: rgba(0,0,0,0) !important;
    }
      /*滚动条样式*/
    .el-table__body-wrapper::-webkit-scrollbar {/*滚动条整体样式*/
        width: 3px;     /*高宽分别对应横竖滚动条的尺寸*/
        height: 5px;
    }
    .el-table__body-wrapper::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
        border-radius: 3px;
        background: #ffff;
    }
    .el-table__body-wrapper::-webkit-scrollbar-track {/*滚动条里面轨道*/
        background: #F6F8F7;
    }
    .el-table{
        th>.cell,td>.cell{
            padding: 0;
        }
        .el-table__body-wrapper{
            width: calc(100% - 8px);
            margin-right: 8px;
        }
    }
    .el-time-panel{
        .el-time-spinner__list::after, .el-time-spinner__list::before{
            height:70px;
        }
    }

    .scrollbar_style{
        // margin-right: 0.5rem;
        overflow: auto;
    }
      /*.scrollbar_style::-webkit-scrollbar-button{
         width: 10px;
         height: 10px;
      }*/
    .scrollbar_style::-webkit-scrollbar {/*滚动条整体样式*/
        width: 0.5rem;     /*高宽分别对应横竖滚动条的尺寸*/
        height: 0.5rem;
    }
    .scrollbar_style::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
        border-radius: 0.5rem;
        background: #DAE6E0;
    }
    .scrollbar_style::-webkit-scrollbar-track {/*滚动条里面轨道*/
        background: #F6F8F7;
    }
    
    #app{
        // margin: 0 auto;
        min-width: 1200px;
        // max-width: 2400px;
        input::-webkit-input-placeholder {
          font-size: 1.37rem;
          font-family: Calibri;
          font-weight: normal;
          color: rgba(58, 99, 111, 0.5);
        }
        .el-checkbox__label,.el-table__empty-text,.btn{
            // font-family: AlibabaPuHuiTiR;
            font-family: Calibri;
        }
        >.scrollbar_style{
            // width: calc(100% - 8px);
            width: calc(100%);
            height: 100%;
            &.padding{
                padding-top: 4.2rem;
            }
        }
    }
    .cn{
        .el-checkbox__input{
            &.is-checked .el-checkbox__inner{
                background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                border-color: rgba(0,0,0,0);
            }
            &.is-indeterminate .el-checkbox__inner{
                background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                border-color: rgba(0,0,0,0);
            }

        }
    }
    .el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover{
        color: initial;
        background-color: #f5f7fa;
    }
    .el-dropdown-menu{
        max-height: 360px;
        .el-dropdown-menu__item{
            &.select{
                color: #409eff;
                font-weight: 700;
            }
        }
    }
    /*room-light*/
    .el-slider,.btn{
        .el-loading-mask{
            background-color:rgba(255,255,255,0.4);
            .el-loading-spinner{
                margin-top: 0;
                top: 0;
                height: 100%;
            }
            .circular{
                width: initial;height: 100%;width: 100%;
            }
        }
        position: relative;
    }
    /*Lights Circadian lights 页面*/
    .el-popover.brightness_slider{
        width: 16rem;height: 2.75rem;line-height: 2.75rem;
        padding: 0;
        .slider_box{
            display: flex;
            justify-content: space-between;
            &.cn{
                .el-slider__runway{
                    .el-slider__bar{
                        background: linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                    }
                    .el-slider__button{
                        background: linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                    }
                }
            }

            .text{
                margin-right: 0.5rem;
                font-size:1rem;
                font-family:AlibabaPuHuiTiB;
                color:rgba(51,51,51,1);
            }
        }
        .el-slider__runway{
            width: 11rem;height: 0.8rem;
            margin: 1rem 0 0 1rem;
            border-radius:0.8rem;
            .el-slider__bar{
                margin-top: 0.15rem;
                height: 0.5rem;
                background-color: rgba(5, 207, 171, 1);
            }
            .el-slider__button-wrapper{
                top: -1rem;
                width: 2.75rem;height: 2.75rem;
                .el-slider__button{
                    width: 0.8rem;height: 0.8rem;
                    border: 0.2rem solid #FFFFFF;
                    background-color: rgba(5, 207, 171, 1);
                }
            }
        }
    }
    .el-popover.color_slider{
        width: 16rem;height: 2.75rem;line-height: 2.75rem;
        padding: 0;
        .slider_box{
            display: flex;
            justify-content: space-between;
            .text{
                margin-right: 0.5rem;
                font-size:1rem;
                font-family:AlibabaPuHuiTiB;
                color:rgba(51,51,51,1);
            }
        }
        .el-slider__runway{
            width: 11rem;height: 0.8rem;
            margin: 1rem 0 0 1rem;
            border-radius:0.8rem;
            .el-slider__bar{
                margin-top: 0.15rem;
                height: 0.5rem;
                background-color: rgba(255, 190, 0, 1);
            }
            .el-slider__button-wrapper{
                top: -1rem;
                width: 2.75rem;height: 2.75rem;
                .el-slider__button{
                    width: 0.8rem;height: 0.8rem;
                    border: 0.2rem solid #FFFFFF;
                    background-color: rgba(255, 190, 0, 1);
                }
            }
        }
    }
    /*Lights Circadian lights 页面*/
    .el-popover.light_dg_slider{
        width: 20rem;
        padding: 0;
        .slider_box{
            p{
                display: flex;
                justify-content: space-between;
                height: 2.75rem;line-height: 2.75rem;
                .span{
                    margin-left: 0.8rem;
                    font-size:1rem;
                    font-family:AlibabaPuHuiTiB;
                    color:rgba(51,51,51,1);
                }
            }
            .text{
                margin-left: 1rem;
                margin-right: 1rem;
                font-size:1rem;
                // font-family:AlibabaPuHuiTiR;
                font-family: Calibri;
                color:rgba(5,207,171,1);
            }
        }
        .el-slider__runway{
            width: 11rem;height: 0.8rem;
            margin: 1rem 0 0 1rem;
            border-radius:0.8rem;
            .el-slider__bar{
                margin-top: 0.15rem;
                height: 0.5rem;
                background-color: rgba(5, 207, 171, 1);
            }
            .el-slider__button-wrapper{
                top: -1rem;
                width: 2.75rem;height: 2.75rem;
                .el-slider__button{
                    width: 0.8rem;height: 0.8rem;
                    border: 0.2rem solid #FFFFFF;
                    background-color: rgba(5, 207, 171, 1);
                }
            }
        }
    }
    .selection {
        opacity: 0.9;
        .el-dialog__body {
        // text-align: center;
        margin-left: 4.87rem;
        .el-radio {
            margin-top: 1.12rem;
            .el-radio__input.is-checked .el-radio__inner {
            border-color: #00C6FF;
            background: #FFFFFF;
            }
            .el-radio__inner {
            border: 2px solid #DCDFE6;
            width: 2.17rem;
            height: 2.17rem;
            // background-color: #FFFFFF;
            &::after{
                background-color: #00C6FF;
                width: 1.12rem;
                height: 1.12rem;
            }
            }
            .el-radio__label {
            font-family: Calibri;
            font-weight: normal;
            font-size: 1.8rem;
            // color: #4C717C;
            }

        }
        

        }
        .el-dialog__footer {
        .el-button{
            width: 7rem;
            height: 2.63rem;

            font-family: Calibri;
            font-weight: normal;
            font-size: 1.64rem;
            color: #4C717C;
            line-height: 0.8rem;
        }
        }
    }
</style>
